import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, createFileRoute } from '@tanstack/react-router';
import LandingView from 'src/components/views/landing-view/landing-view';
import { communicationsSearchSchema } from 'src/modules/shared/schemas/communications-search.schema';

export const Route = createFileRoute('/')({
  component: LandingComponent,
});

// Example to add nested routes
// https://tanstack.com/router/latest/docs/framework/react/examples/basic-file-based
function LandingComponent() {
  const { isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    return (
      <Navigate
        to="/communications"
        search={communicationsSearchSchema.parse({})}
      />
    );
  }

  return <LandingView />;
}
